import React, { useContext, useEffect } from 'react';
import { EngagementView } from './Engagement.view';
import { GetPostStatsLazyQueryHookResult } from '../../../../models/graphql';
import { AnalyticsContext } from '../../AnalyticsProvider';
import { format } from 'date-fns';
import { AnalyticsVisualizationType } from '../AnalyticsDashboard.controller';
import { DateStringFormat } from 'constants/time-formats';

type EngagementControllerProps = {
  loading: boolean;
  getPostStatsDataQuery: GetPostStatsLazyQueryHookResult[0];
  postStats: GetPostStatsLazyQueryHookResult[1]['data'];
  view: AnalyticsVisualizationType;
};
export const EngagementController = ({
  getPostStatsDataQuery,
  loading,
  postStats,
  view
}: EngagementControllerProps) => {
  const { startDate, endDate, selectedProfilesIds } = useContext(AnalyticsContext);
  const formattedStartDate = format(startDate, DateStringFormat);
  const formattedEndDate = format(endDate, DateStringFormat);
  useEffect(() => {
    const executeQuery = async () => {
      await getPostStatsDataQuery({
        variables: { startDate: formattedStartDate, endDate: formattedEndDate, selectedProfilesIds },
        fetchPolicy: 'no-cache'
      });
    };

    if (selectedProfilesIds && selectedProfilesIds.length > 0) {
      executeQuery();
    }
  }, [getPostStatsDataQuery, formattedStartDate, selectedProfilesIds, formattedEndDate]);

  return (
    <EngagementView data={postStats} loading={loading} showBestTime={view === AnalyticsVisualizationType.profile} />
  );
};
